import styled from "styled-components";

export const SplashScreenWrapper = styled.main`
  position: fixed;
  inset: 0;
  width: 100vw;
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #000000;
  isolation: isolate;
`;

export const Glow = styled.div`
  position: absolute;
  width: clamp(160px, 42vw, 360px);
  aspect-ratio: 1;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.035) 34%,
    rgba(255, 255, 255, 0) 70%
  );
  filter: blur(2px);
  z-index: 0;
`;

export const LogoFrame = styled.div`
  position: relative;
  z-index: 1;
  width: clamp(88px, 22vw, 142px);
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  transform-origin: center center;
  will-change: transform, opacity;
`;

export const Logo = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  image-rendering: auto;
  user-select: none;
  pointer-events: none;
`;
